"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminContext = void 0;

var _react = require("react");

var AdminContext = /*#__PURE__*/(0, _react.createContext)(false);
exports.AdminContext = AdminContext;